import React from 'react';
import { Box, CircularProgress, Alert, Typography } from '@mui/material';
import { useSaleFulfillmentDetail } from '../../../../hooks/useSaleFulfillmentDetail';
import { SaleFulfillmentTimeline } from '../SaleFulfillment/SaleFulfillmentTimeline';

interface OrdersTableExpandedRowProps {
  orderId: number;
}

/** Compact SOL/TRL logistics when a mixed-sale order row is expanded. */
export const OrdersTableExpandedRow: React.FC<OrdersTableExpandedRowProps> = ({ orderId }) => {
  const { detail, isLoading, error } = useSaleFulfillmentDetail(orderId);

  return (
    <Box sx={{ py: 1.5, px: 2, bgcolor: 'background.paper' }}>
      {isLoading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            Cargando información de logística…
          </Typography>
        </Box>
      ) : error ? (
        <Alert severity="error" sx={{ py: 0 }}>
          {error}
        </Alert>
      ) : (
        <SaleFulfillmentTimeline groups={detail?.groups ?? []} dense />
      )}
    </Box>
  );
};

export default OrdersTableExpandedRow;
